module.exports = __webpack_public_path__ + "static/media/i8-2-mask.b491b688.png";